var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 4 C 4.895 4 4 4.895 4 6 L 4 20 C 4 21.105 4.895 22 6 22 L 20 22 C 21.105 22 22 21.105 22 20 L 22 6 C 22 4.895 21.104 4 20 4 L 6 4 z M 19 8 C 19.25575 8 19.511531 8.0974688 19.707031 8.2929688 C 20.098031 8.6839688 20.098031 9.3160312 19.707031 9.7070312 L 12.146484 17.267578 C 11.958484 17.455578 11.704453 17.560547 11.439453 17.560547 C 11.174453 17.560547 10.919422 17.455578 10.732422 17.267578 L 7.2792969 13.814453 C 6.8882969 13.423453 6.8882969 12.791391 7.2792969 12.400391 C 7.6702969 12.009391 8.3023594 12.009391 8.6933594 12.400391 L 11.439453 15.146484 L 18.292969 8.2929688 C 18.488469 8.0974688 18.74425 8 19 8 z M 24 8 L 24 20 C 24 22.209 22.209 24 20 24 L 8 24 C 8 25.105 8.895 26 10 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 10 C 26 8.895 25.104 8 24 8 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.03ec240765eb375ade984c417de6ace7.svg";
export { ForwardRef as ReactComponent };